import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LTIDeeplinkingService } from '../../lti/core/ltideeplinking.service';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { ApiService } from '../../rl-common/shared/shared/interfaces/api-service';
import { StrBoolean } from '../../rl-common/shared/shared/types/str-boolean';
import { Assignment } from '../shared/assignment';
import { StudentSubmission } from '../shared/student-submission';
import { Submission } from '../shared/submission';
import { SubmissionService } from './submission.service';

@Injectable({
  providedIn: 'root'
})
export class AssignmentService implements ApiService<Assignment> {
  
  entityType = EntityType[EntityType.ASSIGNMENT];

  constructor(private http : HttpClient, private submissions : SubmissionService, private lti : LTIDeeplinkingService) { }

  getAll = (params : {listId? : string, course? : string, attachToLMS? : StrBoolean}) : Observable<Assignment[]> => this.http.get<Assignment[]>('../rl/assignments', {params : params});
  
  get = (asgmtId: string) : Observable<Assignment> => this.http.get<Assignment>('../rl/assignments/' + asgmtId);

  create = (asgmt: Assignment) : Observable<Assignment> => this.http.post<Assignment>('../rl/assignments', asgmt);

  save = (asgmt: Assignment) : Observable<Assignment> => this.http.put<Assignment>('../rl/assignments', asgmt);

  delete = (asgmt: Assignment) : Observable<void> => this.http.delete<void>('../rl/assignments/' + asgmt.id);

  getStatistics = (asgmtId : string) : Observable<{[val : string] : number}> => this.http.get<{[val : string] : number}>(`../rl/assignments/${asgmtId}/statistics`);

  sort = (asgmtId : number, sectionId : number, newOrder : number) : Observable<void> => this.http.patch<void>(`../rl/main/${this.entityType}/${asgmtId}/order`, {sectionId : sectionId, newOrder : newOrder});

  submit = (sub : Submission) : Observable<Submission> => this.submissions.submit(sub);

  updateSubmission = (sub : Submission) : Observable<Submission> => this.submissions.save(sub);
    
  getSubmissions = (asgmtId : string) : Observable<Submission[]> => this.submissions.getAll(asgmtId);

  getNotGradedStudentSubmissions = (asgmtId : string) : Observable<StudentSubmission[]> => this.submissions.getStudentsNotGraded(asgmtId);

  linkToLti = (asgmtId : string) : void => {
    this.http.get<any>(`../rl/assignments/${asgmtId}/lti`).subscribe(data => this.lti.submitData(data));
  }
}
